import { TableHead } from "@material-ui/core";
import * as types from "./types";

export function updateProfileDetails(details) {
  return {
    type: types.UPDATE_PROFILE_DETAILS,
    details
  };
}

export function fetchAccountDetailsStart() {
  return {
    type: types.FETCH_ACCOUNT_DETAILS_START
  };
}

export function fetchAccountDetailsSuccess(details) {
  return {
    type: types.FETCH_ACCOUNT_DETAILS_SUCCESS,
    details
  };
}

export function updateProfileDetailsStart(details) {
  return {
    type: types.UPDATE_PROFILE_DETAILS_START,
    details
  };
}

export function cancelAccountStart(details) {
  return {
    type: types.CANCEL_ACCOUNT_START,
    details
  };
}

export function cancelAccountFailure(msg) {
  return {
    type: types.CANCEL_ACCOUNT_FAILURE,
    msg
  };
}

export function cancelAccountResetState() {
  return {
    type: types.CANCEL_ACCOUNT_RESET_STATE
  };
}

export function updatePasswordStart(details) {
  return {
    type: types.UPDATE_PASSWORD_START,
    details
  };
}

export function updatePasswordSuccess() {
  return {
    type: types.UPDATE_PASSWORD_SUCCESS
  };
}

export function updatePasswordFailure(msg) {
  return {
    type: types.UPDATE_PASSWORD_FAILURE,
    msg
  };
}

export function updatePasswordResetState() {
  return {
    type: types.UPDATE_PASSWORD_RESET_STATE
  };
}

export function reEnterPasswordStart() {
  return {
    type: types.RE_ENTER_PASSWORD_START
  };
}

export function emailUpdated(permission) {
  return {
    type: types.EMAIL_UPDATED,
    permission
  };
}

export function reEnterPasswordFailure(msg) {
  return {
    type: types.RE_ENTER_PASSWORD_FAILURE,
    msg
  };
}

export function reEnterPasswordResetState() {
  return {
    type: types.RE_ENTER_PASSWORD_RESET_STATE
  };
}

function showNotification(details) {
  return {
    type: types.SHOW_ACCOUNT_NOTIFICATION,
    details
  };
}

export function hideAccountNotification() {
  return {
    type: types.HIDE_ACCOUNT_NOTIFICATION
  };
}

export function showAccountNotificationWithTimeout(details) {
  return dispatch => {
    let timer = null;
    dispatch(showNotification(details));

    timer = setTimeout(() => {
      dispatch(hideAccountNotification());
      clearTimeout(timer);
    }, 5000);
  };
}

export function initiateAccountActivityChange() {
  return {
    type: types.INITIATE_ACCOUNT_ACTIVITY_CHANGE
  };
}

export function upgradePlanStart(details, plan) {
  return {
    type: types.UPGRADE_PLAN_START,
    details,
    plan
  };
}

export function upgradePlanSuccess() {
  return {
    type: types.UPGRADE_PLAN_SUCCESS
  };
}

export function updateCreditCardStart(details) {
  return {
    type: types.UPDATE_CREDIT_CARD_START,
    details
  };
}

export function updateCreditCardSuccess() {
  return {
    type: types.UPDATE_CREDIT_CARD_SUCCESS
  };
}

export function fetchCCDetailsStart() {
  return {
    type: types.FETCH_CC_DETAILS_START
  };
}

export function fetchCCDetailsSuccess(data) {
  return {
    type: types.FETCH_CC_DETAILS_SUCCESS,
    data
  };
}

export function fetchBillingInfoStart() {
  return {
    type: types.FETCH_BILLING_INFO_START
  };
}

export function fetchBillingInfoSuccess(details) {
  return {
    type: types.FETCH_BILLING_INFO_SUCCESS,
    details
  };
}

export function changeToPaidPlan(plan) {
  return {
    type: types.CHANGE_TO_PAID_PLAN,
    plan
  };
}

export function fetchRenewalPriceStart() {
  return {
    type: types.FETCH_RENEWAL_PRICE_START
  };
}

export function fetchRenewalPriceSuccess(data) {
  return {
    type: types.FETCH_RENEWAL_PRICE_SUCCESS,
    data
  };
}

export function fetchUpgradeProChargeStart(details, openPop) {
  return {
    type: types.FETCH_UPGRADE_PROP_CHARGES_START,
    details,
    openPop
  };
}

export function fetchUpgradeProChargeSuccess() {
  return {
    type: types.FETCH_UPGRADE_PROP_CHARGES_SUCCESS
  };
}

export function initiateUpgradePlan(plan) {
  return {
    type: types.INITIATE_UPGRADE_PLAN,
    plan
  };
}

export function fetchUserPlansStart() {
  return {
    type: types.FETCH_USER_PLANS_START
  };
}

export function fetchUserPlansSuccess(data) {
  return {
    type: types.FETCH_USER_PLANS_SUCCESS,
    data
  };
}

export function accountSettingsChangedPNSStart() {
  return {
    type: types.ACCOUNT_SETTINGS_CHANGED_PNS_START
  };
}

export function cancelAccountPNSStart() {
  return {
    type: types.CANCEL_ACCOUNT_PNS_START
  };
}

export function applyPendingChargesStart(details) {
  return {
    type: types.APPLY_PENDING_CHARGES_START,
    details
  };
}

export function applyPendingChargesFailed() {
  return {
    type: types.APPLY_PENDING_CHARGES_FAILED
  };
}
